const routingDataElement = document.querySelector('[data-component="routing-data"]');
const routingData = routingDataElement?.innerHTML ? JSON.parse(routingDataElement.innerHTML) : {};
const currentUrl = new URL(window.location);

const initialState = {
  currentUrl,
  urlSubdirectory: routingData.urlSubdirectory || '',
  urlPaging: routingData.urlPaging || '',
  urlQueryString: currentUrl.searchParams.toString(),
  urlLocation: routingData.urlLocation || '',
  urlBuilderName: routingData.urlBuilderName || '',
  urlCoordinatesQueryString: routingData.urlCoordinatesQueryString || '',
}

export default initialState;